// Need this to be part of the global state
export const SCROLL_DEBOUNCE_TIME = 1000;
export const TABLE_ROW_SIZE = 55;
export const GRID_SIZE = 100;

export const THUMBNAIL_SIZE_GRID = 90;
export const THUMBNAIL_SIZE_GRID_SELECTED = 82;
export const THUMBNAIL_SIZE_LIST = 55;

// Need to consolidate
export const IMAGE_EXT = [
  '.gif',
  '.png',
  '.bmp',
  '.jpg',
  '.jpeg',
  '.jfif',
  '.pjpeg',
  '.pjp',
  '.webp',
];

export const TEXT_EXT = ['.txt', '.doc', '.csv', '.rtf'];

export const ARCHIVE_EXT = ['.zip', '.tar'];

export const VIDEO_EXT = ['.mp4', '.mov', '.wmv', '.avi'];

export enum VIEW_TYPE {
  GRID = 'grid',
  LABEL = 'label',
  LIST = 'list',
}

export enum FILE_TYPE {
  IMAGE = 'image',
  VIDEO = 'video',
  ARCHIVE = 'archive',
  TEXT = 'text',
  FILE = 'file', //default
}

export const ACCEPTED_FILES = [...IMAGE_EXT, ...VIDEO_EXT].join();

const FILE_TYPE_ARR = [
  'image',
  'video',
  'archive',
  'text',
  'file', //default
];
const EXT_LIST = [IMAGE_EXT, VIDEO_EXT, ARCHIVE_EXT, TEXT_EXT];
export const getFileTypeFromFilename = (filename: string): string => {
  const ext = '.' + filename.split('.').pop() || '';

  for (let index = 0; index < EXT_LIST.length; index++) {
    const cExtList = EXT_LIST[index];
    if (cExtList.includes(ext.toLowerCase())) return FILE_TYPE_ARR[index];
  }
  return 'file';
};
